export default "__VITE_ASSET__NzEie6vt__"